module.exports = __webpack_public_path__ + "static/media/1.bb14b2bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80680/1.jpg
// module id = 812
// module chunks = 0